import { ErrorBase } from '@/common/errors'

export class GroupNotFoundError extends ErrorBase {
  constructor(msg: string) {
    super(msg, GroupNotFoundError)
  }
}
